import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Initial state can be empty
const initialState: any = {};

const userKybSlice = createSlice({
  name: 'userKybSlice',
  initialState,
  reducers: {
    setUserKyb(state, action: PayloadAction<any>) {
      console.log(state, action.payload);
      return { ...state, ...action.payload };
    },
    clearUserKyb(state) {
      return { ...initialState };
    },
  },
});

export const { setUserKyb, clearUserKyb } = userKybSlice.actions;
export const userKybReducer = userKybSlice.reducer;

// Selector
export const selectUserKyb = (state: any) => state.userKyb;
